import React from 'react'
import { Message, Form, Icon, Popup, Checkbox, Label } from 'semantic-ui-react'
import { useDocumentDataOnce } from 'react-firebase-hooks/firestore'
import Link from 'next/link'

import useUpdateUserData from 'lib/hooks/useUpdateUserData'
import MultiSelectDropdownField from 'lib/components/MultiSelectDropdownField'
import useFirebase from 'lib/hooks/useFirebase'
import { useAuth } from 'lib/context/AuthContext'

import { categories } from '../../../../src/shared/categories'

const NotificationSettings = () => {
  const updateUserData = useUpdateUserData()
  const firebase = useFirebase()
  const [stats, loading, error] = useDocumentDataOnce<{
    [key: string]: string[]
  }>(firebase.firestore().doc('site/stats'))
  const [user] = useAuth()

  return (
    <>
      <Message
        attached="top"
        header="Notification Settings"
        content={
          <>
            <p>
              Configure what types of alerts you want to be notified of.
              Confusing? <Link href="/setup">Try the Setup Wizard</Link>
            </p>
          </>
        }
        size="tiny"
      />
      <Form className="attached fluid segment" size="large">
        <Form.Field
          control={Checkbox}
          label="Pause Notifications"
          toggle
          checked={user.data.neverNotify}
          onChange={(evt, data) => {
            updateUserData({
              neverNotify: data.checked,
            })
          }}
          css={{
            marginBottom: user.data.neverNotify ? '0 !important' : 'inherit',
          }}
        />
        {user.data.neverNotify && (
          <Label
            pointing="above"
            basic
            css={{
              marginBottom: '1rem !important',
              color: '#9f3a38!important',
            }}
          >
            You will not receive any notifications until you turn this off.
          </Label>
        )}

        <MultiSelectDropdownField
          id="categories"
          label="Filter: Categories"
          placeholder="Select Categories to filter by"
          value={user.data.categories}
          options={Object.keys(categories).flatMap(key => categories[key])}
          onChange={(evt, data) => {
            updateUserData({
              categories: data.value,
            })
          }}
        />

        <MultiSelectDropdownField
          id="keywords"
          label="Filter: Keywords"
          placeholder="Add keywords to filter by"
          noResultsMessage="Add keyword with Enter"
          allowAdditions
          value={user.data.keywords}
          options={user.data.keywords}
          onChange={(evt, data) => {
            updateUserData({
              keywords: data.value,
            })
          }}
        />

        <MultiSelectDropdownField
          id="alertTypes"
          label={
            <label htmlFor="alertTypes">
              Filter: Alert Types
              <Popup
                trigger={
                  <Icon
                    name="info circle"
                    color="blue"
                    style={{
                      marginLeft: '0.25rem',
                    }}
                  />
                }
                content="You might get a lot of alerts if you use this setting! Usually picking from Categories is better."
                hoverable
              />
            </label>
          }
          placeholder="Select Alert Types to filter by"
          value={user.data.alertTypes}
          options={stats?.alertTypes.sort() ?? []}
          loading={loading || error}
          onChange={(evt, data) => {
            updateUserData({
              alertTypes: data.value,
            })
          }}
        />
      </Form>
    </>
  )
}

export default NotificationSettings
